import { useStaticQuery, graphql } from "gatsby"

export const useServicesQuery = () => {
  const { wpPage } = useStaticQuery(
    graphql`
      query ServicesQuery {
        wpPage(title: { eq: "Home" }) {
          services {
            servicesBackgroundImageDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            servicesBackgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(quality: 100)
                }
              }
            }
            servicesBackgroundImageAltText
            servicesHeading
            servicesSubheading
            servicesServiceTabs {
              servicesTabIcon {
                localFile {
                  childSvg {
                    content {
                      data
                    }
                  }
                }
              }
              servicesTabLabel
              servicesTabContent
              servicesTabServices {
                servicesTabServicesIcon {
                  localFile {
                    childSvg {
                      content {
                        data
                      }
                    }
                  }
                }
                servicesTabServicesLabel
                servicesTabServicesImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                servicesTabServicesImageAltText
                servicesTabServicesContent
                servicesTabServicesLink {
                  title
                  url
                }
              }
            }
          }
        }
      }
    `
  )
  return wpPage.services
}
